module.exports = __webpack_public_path__ + "static/media/CREAM.2ae0e783.svg";